
import React from 'react';
import PropTypes from 'prop-types';

const FavoritesIconFilled = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            className={`fill-current ${className}`}
            fill="currentColor">
            <path d="M13.8809 1.6665C12.2454 1.6665 10.7817 2.46164 9.86908 3.68144C8.95648 2.46164 7.49272 1.6665 5.85728 1.6665C3.08336 1.6665 0.833496 3.9254 0.833496 6.71739C0.833496 7.79263 1.00517 8.78654 1.30335 9.70817C2.73097 14.226 7.1313 16.9276 9.30887 17.6685C9.61608 17.7769 10.1221 17.7769 10.4293 17.6685C12.6069 16.9276 17.0072 14.226 18.4348 9.70817C18.733 8.78654 18.9047 7.79263 18.9047 6.71739C18.9047 3.9254 16.6548 1.6665 13.8809 1.6665Z" fill="currentColor"/>
        </svg>
    );
};

FavoritesIconFilled.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

FavoritesIconFilled.defaultProps = {
    className: '', // Default to an empty string
};

export default FavoritesIconFilled;